import React, { useEffect, useState } from "react";
import CreateRecruitmentPage from "../../../../entities/DashboardPage/HRModule/CreateRecruitmentPage";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";
import { useLocation, useNavigate } from "react-router-dom";

const CreateRecruitment = () => {
  const {showAlert} = useAlert();
  const navigate = useNavigate();
  const {state} = useLocation();
  const {id,from} = state || {};
  const [data,setData] = useState([]);
  const [loading,setLoading] = useState(false);

  useEffect(() => {
    if(id && from === "Edit"){
      getRecruitment(id);
    }
  },[])

  const getRecruitment = async (id) => {
    LoaderHelper.loaderStatus(true);
    
    try {
      const result = await AuthService.getRecruitmentDetail(id);
      if (result?.success) {
        
        setData(result?.data)
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  }
  const handleAddRecruitment =  async (position,company,quantity,department,workplace,displaySalary,startingSalaryFrom,startingSalaryTo,reason,desc,fromDate,toDate,workingFrom) => {
    setLoading(true);
    
    try {
      const result = await AuthService.handleAddRecruitment(position,company,quantity,department,workplace,displaySalary,startingSalaryFrom,startingSalaryTo,reason,desc,fromDate,toDate,workingFrom);
      if (result?.success) {
        showAlert(result?.message, "success");
        navigate("/dashboard/recruitment")
        setLoading(false);
      } else {

        setLoading(false);
      }
    } catch (error) {

      setLoading(false);
    }
  }
  const updateRecruitment = async(position,company,quantity,department,workplace,displaySalary,startingSalaryFrom,startingSalaryTo,reason,desc,fromDate,toDate,workingFrom) => {
    LoaderHelper.loaderStatus(true);
    
    try {
      const result = await AuthService.updateRecruitment(position,company,quantity,department,workplace,displaySalary,startingSalaryFrom,startingSalaryTo,reason,desc,fromDate,toDate,workingFrom,id);
      if (result?.success) {
        showAlert(result?.message, "success");
        navigate("/dashboard/recruitment")
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  }
  return (
    <CreateRecruitmentPage handleAddRecruitment={handleAddRecruitment} data={data} from={from} updateRecruitment={updateRecruitment} loading={loading}/>
  )
}

export default CreateRecruitment;
